var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M155.9015,285.4574,289.5487,419.1046a11.5716,11.5716,0,0,0,16.3649,0L494.1107,230.9075a11.5716,11.5716,0,0,0,0-16.3649l-38.1849-38.1849a11.5717,11.5717,0,0,0-16.365,0l-46.3674,46.3674-87.28,87.28a11.5718,11.5718,0,0,1-16.3649,0l-79.0974-79.0974a11.5718,11.5718,0,0,0-16.3649,0l-38.1849,38.185A11.5716,11.5716,0,0,0,155.9015,285.4574Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.0985,214.5426,210.4513,80.8954a11.5716,11.5716,0,0,0-16.3649,0L5.8893,269.0925a11.5716,11.5716,0,0,0,0,16.3649L139.5365,419.1046a11.5717,11.5717,0,0,0,16.365,0L194.0864,380.92a11.5719,11.5719,0,0,0,0-16.365l-79.0973-79.0973a11.5716,11.5716,0,0,1,0-16.3649l79.0973-79.0974a11.5718,11.5718,0,0,1,16.3649,0l79.0974,79.0974a11.5718,11.5718,0,0,0,16.3649,0l38.1849-38.185A11.5716,11.5716,0,0,0,344.0985,214.5426Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.1c6bfcdde8f86ed91910eae9dcb9a499.svg";
export { ForwardRef as ReactComponent };